import { Alignment, ButtonStyle, ImageFit, Visibility } from '@bigcommerce/page-builder-sdk';

import { ActionTypes } from './actions';
import { CurrencyElement, ProductDynamicData } from './productDynamicData';

export interface ProductImageElement {
    visibility: Visibility;
    imageFit?: ImageFit;
}

export interface ProductProtectedNamespace {
    context?: {
        activeCurrencyCode: string;
        // Subfolder for the locale currently being browsed (e.g. "/de"), or "" on the default locale.
        // Provided by the storefront so relative product paths can be resolved under the active locale.
        localeSubfolder?: string;
    };
    id: string;
    data?: ProductDynamicData;
}

interface FontSize {
    value: number;
    type: string;
}

interface BrandElement {
    visibility: Visibility;
    color: string;
    textStyle: TextStyle;
}

interface ProductNameElement {
    visibility: Visibility;
    color: string;
    textStyle: TextStyle;
}

interface PriceElement {
    visibility: Visibility;
    color: string;
    textStyle: TextStyle;
}

interface ProductRatingElement {
    visibility: Visibility;
    starColorFilled: string;
    starColorEmpty: string;
    reviewsColor: string;
}

interface ButtonElement {
    visibility: Visibility;
    shape: ButtonStyle;
    buttonActionType: ActionTypes;
    buttonColor: string;
    buttonTextColor: string;
    textStyle: TextStyle;
}

export enum TextStyle {
    BODY_TEXT = 'global_typography_body_text',
    CUSTOM = 'custom',
    DEFAULT = 'default',
    HEADING_1 = 'global_typography_h1',
    HEADING_2 = 'global_typography_h2',
    HEADING_3 = 'global_typography_h3',
    HEADING_4 = 'global_typography_h4',
    HEADING_5 = 'global_typography_h5',
    HEADING_6 = 'global_typography_h6',
    SECONDARY_TEXT = 'global_typography_secondary_text',
}

export interface ProductProps {
    _: ProductProtectedNamespace;
    brand: BrandElement;
    button: ButtonElement;
    displayLocale?: string;
    productCardContentAlignment: Alignment;
    productName: ProductNameElement;
    productRating: ProductRatingElement;
    productImage: ProductImageElement;
    productId: string;
    price: PriceElement;
}

export interface ProductCardProps {
    actionLabel: string;
    actionLink: string;
    name: string;
    brand: string;
    buttonVisibility: Visibility;
    plpTaxSetting: string;
    priceWithTax?: number;
    priceWithoutTax?: number;
    currencyCode?: string;
    currencyDisplay?: CurrencyElement;
    displayLocale: string;
    path?: string;
    productImage?: string;
    productImageFit: ImageFit;
    rating: number;
    starColorEmpty: string;
    starColorFilled: string;
    totalReviews: number;
}
